module.exports = __webpack_public_path__ + "static/media/binnen_slaapkamer_noord.51bec8f7.jpg";